<script setup lang="ts">
import type { ComboboxGroupProps } from "./combobox.types";
import { useComboboxGroup } from "./useCombobox.Group";

defineOptions({ name: "ComboboxGroup" });

defineProps<ComboboxGroupProps>();

const { classes } = useComboboxGroup();
</script>

<template>
  <div part="base" :class="classes.base" class="e-combobox-group e-listbox-group" role="group" :aria-label="label">
    <div v-if="label" part="label" :class="classes.label" class="e-combobox-group-label e-listbox-group-label">
      {{ label }}
    </div>
    <slot />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
